import { useEffect } from "react";

// Note: this is needed due to an iOS-26 bug where screensize is calculated wrongly
// after tapping and holding a link (skuttdyrCard) to open link preview.
// If bug is fixed, this file can be removed, and Layout.tsx can be changed back:
// replace <div className="flex flex-col items-center" style={{ height: "var(--app-vh)" }}>
// with   <div className="h-dvh flex flex-col items-center">
// and replace
// <div className="sticky w-dvw max-w-244" style={{ top: "var(--app-vh)" }} ref={navbarRef}>
//   <NavigationDefault id="mainPageNavigation" />
// </div>
// with
// <div className={`sticky top-[100vh] w-dvw max-w-244`} ref={navbarRef}>
//   <NavigationDefault id="mainPageNavigation" />
// </div>

export function useViewportVars() {
  useEffect(() => {
    const root = document.documentElement;
    const vv = window.visualViewport;

    const compute = () => {
      const clientH = document.documentElement.clientHeight; // stable on iOS-26 bug
      root.style.setProperty("--app-vh", `${clientH}px`);
    };

    const update = () => {
      compute();
      setTimeout(compute, 50);
      setTimeout(compute, 250);
    };

    update();

    vv?.addEventListener("resize", update);
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") update();
    });
    window.addEventListener("pageshow", update);

    return () => {
      vv?.removeEventListener("resize", update);
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      window.removeEventListener("pageshow", update);
    };
  }, []);
}
